import styled from 'styled-components';
import TinyColor from 'tinycolor2';
import { Button } from 'components/core';

export const ReorderButton = styled(Button)`
  /* Match ProductCard tinted button styles from card-view.tsx */
  /* Hex alpha 10% */
  background: ${({ theme }) => theme.customized.colors.buttonsLinks}1a;
  color: ${({ theme }) => TinyColor.mix(theme.customized.colors.buttonsLinks, '#000', 20).toString()};
  border: none;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.customized.colors.buttonsLinks};
    color: ${({ theme }) => theme.colors.white};
  }
`;
